<script setup lang="ts">
  import { MpSelect, MpText, useMpScreen } from '@borg/ui';
  import { injectSearchBar } from './useSearchBar';

  const { t } = useI18n();
  const { breakpoints } = useMpScreen();
  const searchBar = injectSearchBar();
  const isLargeScreen = computed(() => breakpoints.isLg);

  const search = useDebounceFn(async (keyword: string) => {
    const result = await positionsService.search(keyword);
    return result.isSuccess ? result.data : [];
  });

  function onBlur(event: FocusEvent) {
    const inputElement = event.target instanceof HTMLInputElement ? event.target : null;
    const focusElement =
      event.relatedTarget instanceof HTMLButtonElement ? event.relatedTarget : null;
    if (
      inputElement &&
      inputElement.value &&
      focusElement &&
      focusElement.innerText === t('SEARCH')
    ) {
      searchBar.createKeyword(inputElement.value);
    }
    if (breakpoints.isLg) {
      searchBar.close();
    }
  }
</script>

<template>
  <MpSelect
    v-model="searchBar.selectedPositions"
    :placeholder="$t('SEARCH_BAR.POSITIONS_PLACEHOLDER')"
    :options="search"
    :get-value="(option) => option.id"
    :get-label="(option) => option.name"
    :resolve-on-load="false"
    :is-open="searchBar.dropdownTarget === 'positions-autocomplete'"
    :wrap-tags="false"
    :removable-tags="isLargeScreen"
    :show-arrow="false"
    :dropdown-offset="15"
    :dropdown-radius="15"
    :preselect="false"
    :creatable="true"
    mode="multiple"
    size="lg"
    searchable
    variant="ghost"
    :aria-label="$t('SEARCH_BAR.POSITIONS_PLACEHOLDER')"
    name="positions"
    autocomplete="off"
    @click="searchBar.open('positions-menu')"
    @focus="searchBar.open('positions-menu')"
    @blur="onBlur"
    @keydown="searchBar.onKeyDown($event, 'positions')"
    @create="searchBar.createKeyword"
    @update:query="searchBar.onUpdatePositionKeyword"
  >
    <template #default="{ option }">
      <div class="option">
        <MpText
          type="body1"
          no-margin
        >
          {{ option.name }}
        </MpText>
      </div>
    </template>
  </MpSelect>
</template>

<style scoped lang="scss">
  .option {
    display: flex;
    align-items: center;
    gap: var(--mp-space-40);
    padding: var(--mp-space-20) var(--mp-space-40);
    cursor: pointer;
  }
</style>
